import localeEs from "@angular/common/locales/es-mx";
import { registerLocaleData } from "@angular/common";
import { NgModule, ApplicationRef, LOCALE_ID } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { FormsModule } from "@angular/forms";

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from "./app.routing";
// App is our top level component
import { AppComponent } from "./app.component";
import { APP_RESOLVER_PROVIDERS } from "./app.resolver";
import { AppState, InternalStateType } from "./app.service";

// Core providers
import { CoreModule } from "./core/core.module";
import { SmartadminLayoutModule } from "./shared/layout/layout.module";

import { ModalModule } from "ngx-bootstrap/modal";

// Application wide providers
const APP_PROVIDERS = [...APP_RESOLVER_PROVIDERS, AppState];

// Registrar los datos en español
registerLocaleData(localeEs);

type StoreType = {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    // import Angular's modules
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,

    ModalModule.forRoot(),

    CoreModule,
    SmartadminLayoutModule,

    routing,
  ],
  exports: [],
  providers: [
    // expose our Services and Providers into Angular's dependency injection
    { provide: LOCALE_ID, useValue: "es-mx" },
    // ENV_PROVIDERS,
    APP_PROVIDERS,
  ],
})
export class AppModule {
  constructor(
    public appRef: ApplicationRef,
    public appState: AppState,
  ) {}
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/app.module.ts